<template>
    <div>
        <el-upload
                class="upload-demo"
                drag
                :file-list="fileList"
                :http-request="httpRequest"
                :before-upload="beforeUpload"
                :limit="limit"
                :before-remove="beforeRemove"
                multiple>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <!-- <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div> -->
        </el-upload>
    </div>
</template>
<script>
import { putFile, downloadFile } from "@/api/common.js";
import website from "@/config/website";
export default {
     props: {
    fileList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    types: {
      type: Array,
      default: ['bin']
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    max: {
      type: Number,
      default: 12 * 1024 * 1024,
    },
    limit: {
      type: Number,
      default: 3,
    },
    message:{
      default:''
    }
  },
  watch: {
    fileList() {
      let len = this.fileList.length;
      this.limitDisabled = len >= this.limit;
    },
  },
  data() {
    return {
      maskShow: false,
      maskItem: {},
      limitDisabled: false,
      mediaElement: null,
    };
  },
  methods:{
    handlePictureCardPreview(file) {
      console.log("213==>", 213);
      console.log("file==>", file);
      this.maskItem = file;
      this.maskShow = true;
    },
    //同步数据到父组件
    update() {
      // status:'success' 后端会报错
    

      this.$emit("update:fileList", this.fileList);
    },
    beforeUpload(file) {
      console.log("beforeUpload==>",file);
   
      let extension = file.name.split('.').pop()
      console.log('extension==>',extension);
     if(!this.types.includes(extension.toLocaleLowerCase())){
       this.$message.warning('仅支持'+this.types.toString()+'文件格式')
       return  false
     }
      if (this.limitDisabled) {
        return false

      };
      this.max = this.max || website.maxUploadSize;
      if (file.size > this.max) {

        this.$message.error(`文件不能大于${this.max / (1024 * 1024)}MB`);
        return false;
      }
       this.fileList.push(file)
      this.update();
    },
    //上传方法
    httpRequest(file) {
        console.log('文件',this.file)
        //    this.fileList.push(fileList);
       
        
        console.log("this.httpRequest.fileList= =>", this.fileList);
       
    },
    //移除
    beforeRemove(file){
       let deleteIndex;
      this.fileList.forEach((item, index) => {
        if (item == file) {
          deleteIndex = index;
        }
      });
      if (deleteIndex !== undefined) {
        this.fileList.splice(deleteIndex, 1);
      }
      this.update();
    },
    handleRemove(file) {
      let deleteIndex;
      this.fileList.forEach((item, index) => {
        if (item == file) {
          deleteIndex = index;
        }
      });
      if (deleteIndex !== undefined) {
        this.fileList.splice(deleteIndex, 1);
      }
      this.update();
    },
    //下载方法
    handleDownload(file) {
      console.log("file==>", file);
      downloadFile(file.link, file.originalName);
    },
  }
}
</script>